export default [
  {
    path: "/my-content",
    name: "my-content",
    meta: { title: "My-Content" },
    component: () => import("../views/content/content-list.vue")
  }
]